import { useTranslation } from "react-i18next";

import { interpolate, Route, useRouter } from "@sol/routing";

import { ClassroomLayout } from "../../components/layouts/ClassroomLayout";
import MetaTitle from "../../components/MetaTitle";
import { RedirectResult } from "../../components/RedirectResult";

/**
 * Temporarly redirect briefs details to the active classroom.
 * @deprecated this will be removed when documentation will be updated
 * @TODO remove this in 120j from "2025-01-21"
 */
function ClassroomBriefRedirectResult() {
    const router = useRouter();
    const [t] = useTranslation();

    return (
        <div className="flex size-full flex-col items-center justify-center">
            <RedirectResult
                status="info"
                title={t("page.briefs.redirection.title")}
                message={t("page.briefs.redirection.message")}
                to={interpolate(Route.BRIEFS_DETAILS, {
                    id: router.query.briefId,
                })}
            />
        </div>
    );
}

const TempBriefRedirect = () => {
    const [t] = useTranslation();

    return (
        <>
            <MetaTitle />
            <ClassroomLayout title={t("page.classrooms.dashboard.title")}>
                <ClassroomBriefRedirectResult />
            </ClassroomLayout>
        </>
    );
};

export default TempBriefRedirect;
